module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chblockx"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("We can’t stop tornadoes. But we can live"), _c('br'), _vm._v("through them when we know how.")]), _vm._v(" "), _c('p', {
    staticClass: "chattributex"
  }, [_c('em', [_vm._v("Tornado Warning: A Booklet for Boys and Girls")]), _vm._v(" (1981)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 90
// module chunks = 0